"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PREFIX = void 0;
const { v1: uuidv1 } = require('uuid');
exports.DEFAULT_PREFIX = 'idPeticion';
/**
 * Genera un UUID con un prefijo personalizado.
 * @param {string} idFront - Identificador adicional que se desea agregar al UUID.
 * @param {string} [prefix=DEFAULT_PREFIX] - Prefijo personalizado para el UUID.
 * @param {boolean} [equalSignal=true] - Indica si se debe agregar un signo igual (=) después del prefijo.
 * @returns {string} - UUID generado con el prefijo y el identificador adicionales.
 */
const getUUID = (idFront = '', prefix = exports.DEFAULT_PREFIX, equalSignal = true) => {
    const v1options = {
        node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
        clockseq: 0x1234,
        msecs: new Date().getTime(),
        nsecs: 5678,
    };
    let uuid = uuidv1(v1options);
    uuid = uuid.replace(/-/g, '');
    uuid = uuid.toUpperCase();
    const res = `${prefix}${equalSignal ? '=' : ''}${idFront}${uuid}`;
    return res;
};
exports.default = getUUID;
//# sourceMappingURL=index.js.map